import { z, isoZ } from 'my-zod'

export const warehousesModel = z.object({
  id: z.number(),
  warehouseName: z.string().nullable(),
  userIds: z.number().array(),
  uploadBlobUrl: z.string().nullable(),
  expectedMobileAppVersion: z.number().nullable(),
  expectedMobileAppVersionUrl: z.string().nullable(),
  extraFeatures: z.string().array().nullable(),
  lastModifiedDate: isoZ.instant().nullable(),
  deletedDate: isoZ.instant().nullable(),
  deviceFriendlyNamePrefix: z.string().nullable()
})

export type warehousesModel = z.infer<typeof warehousesModel>
